import React, { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import { loadDesignSystemScript } from '../utils/loadScript';
import { loadDesignSystemCSS } from '../utils/loadCSS';

const REQUIRED = [
  'Alert',
  'Badge',
  'Button',
  'Card',
  'CardError',
  'Checkbox',
  'ComboBox',
  'Dropdown',
  'Header',
  'IconButton',
  'Input',
  'Loader',
  'MenuItem',
  'MenuItemUser',
  'Modal',
  'ModalProcess',
  'Skeleton',
  'SvgIcon',
  'SvgImage',
  'Table',
  'Tabs',
];

function resolveDesignSystemGlobal() {
  const g = window.DesignSystem;
  const base = g?.default ?? g;
  if (!base) return null;
  return typeof base === 'function' ? base() : (base.components ?? base);
}

function assertRequired(obj, keys) {
  const missing = keys.filter((k) => !obj?.[k]);
  if (missing.length) {
    throw new Error(`[DesignSystem] Faltan componentes: ${missing.join(', ')}`);
  }
}

export const useDesignSystem = () => {
  const [components, setComponents] = useState(null);

  useEffect(() => {
    window.React = React;
    window.ReactDOM = ReactDOM;
    loadDesignSystemCSS();

    let mounted = true;
    loadDesignSystemScript()
      .then(() => {
        const lib = resolveDesignSystemGlobal();
        if (!lib) throw new Error('No se pudo resolver window.DesignSystem.');
        assertRequired(lib, REQUIRED);
        if (mounted) setComponents(lib);
      })
      .catch((err) => {
        console.error(err);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return components;
};
